// 定义全局平台标识
const platformCode = window.g.platformCode;
export default {
  platformCode
};



// WEBPACK FOOTER //
// ./src/utils/global-variable.js